import { Controller } from "@hotwired/stimulus"

const LABEL_COLOR = "#8A8984"

// Daily calls as bars and estimated cost as a line on its own axis.
export default class extends Controller {
  static targets = ["chart"]
  static values = { chartData: Object }

  loadChart() { return import("chart.js/auto") }

  async connect() {
    const connection = this.connection = {}
    try {
      const { Chart } = await this.loadChart()
      if (this.connection !== connection) return
      const data = this.chartDataValue
      this.chart = new Chart(this.chartTarget, {
        data: {
          labels: data.labels,
          datasets: [
            { type: "bar", label: data.calls_label, data: data.calls, backgroundColor: "#C7D2FE", yAxisID: "calls" },
            { type: "line", label: data.cost_label, data: data.cost, borderColor: "#E25015", backgroundColor: "#E25015", pointRadius: 0, tension: 0.3, yAxisID: "cost" }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: "index", intersect: false },
          plugins: { legend: { position: "bottom", labels: { boxWidth: 9, boxHeight: 9, color: "#5F5E5A", font: { size: 11 } } } },
          scales: {
            x: { grid: { display: false }, border: { display: false }, ticks: { autoSkip: true, maxRotation: 0, color: LABEL_COLOR, font: { size: 10 } } },
            calls: { position: "left", beginAtZero: true, grid: { color: "#F1F1EF" }, ticks: { color: LABEL_COLOR, font: { size: 10 } } },
            cost: { position: "right", beginAtZero: true, grid: { display: false }, ticks: { color: LABEL_COLOR, font: { size: 10 }, callback: value => `$${value}` } }
          }
        }
      })
    } catch (error) {
      if (this.connection === connection) this.dispatch("error", { detail: { error } })
    }
  }

  disconnect() {
    this.connection = null
    this.chart?.destroy()
    this.chart = null
  }
}
